import { Config } from '../utils/config';
import { getAccessToken } from '../utils/sessionStorageUtils';
import { createUnauthenticatedError } from './UnauthenticatedError';

interface FetchMethodProps {
    url: string;
    method: 'GET' | 'PUT' | 'POST' | 'PATCH' | 'DELETE';
    headers?: HeadersInit;
    body?: object;
}

export async function fetchMethod<T>({
    url,
    method,
    headers,
    body,
}: FetchMethodProps): Promise<T | undefined> {
    let fetchData: T | undefined = undefined;
    const fetchUrl = `${Config.BaseApiUrl}/originations-review-portal${url}`;
    const accessToken = getAccessToken();

    if (!accessToken) {
        throw createUnauthenticatedError();
    }

    const fetchResp = await fetch(fetchUrl, {
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(['PUT', 'POST', 'PATCH'].includes(method)
                ? { 'Content-Type': 'application/json' }
                : {}),
            ...headers,
        },
    });

    if (fetchResp.ok) {
        fetchData = (await fetchResp.json()) as T;
    }

    return fetchData;
}
